import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import { useIntl } from 'react-intl';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import SectionContactUs from './SectionContactUs/SectionContactUs';
import SectionCompanyDetails from './SectionCompanyDetails/SectionCompanyDetails';

import css from './ContactUsPage.module.css';
import classNames from 'classnames';

const ContactUsPageComponent = props => {
  const { scrollingDisabled, email, name, userId, onManageDisableScrolling } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'ContactUsPage.title' });

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="ContactUsPage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <SectionContactUs
          className={classNames(css.section, css.sectionGrey)}
          email={email}
          name={name}
          userId={userId}
          onManageDisableScrolling={onManageDisableScrolling}
        />
        <hr className={css.divider} />
        <SectionCompanyDetails className={classNames(css.section, css.sectionWhite)} />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { email, profile } = state?.user?.currentUser?.attributes || {};
  const { firstName, lastName } = profile || {};

  return {
    scrollingDisabled: isScrollingDisabled(state),
    email,
    name: firstName && lastName ? `${firstName} ${lastName}` : undefined,
    userId: state?.user?.currentUser?.id?.uuid,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const ContactUsPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContactUsPageComponent);

export default ContactUsPage;
